import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap'

import { LocaleModule } from 'common/locale/module'
import { ElementsClientNotRunningModalComponent } from './components/elementsClientNotRunningModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModalModule,
    LocaleModule.forChild(),
  ],
  declarations: [
    ElementsClientNotRunningModalComponent,
  ],
})
export class UtilElementsClientModule { }

export { ElementsClientService } from './services/elementsClient.service'
